/* Figma's wrapper frame around each section: FILL across the column, HUG down
 * it, with the plate parked at one side. */
.section {
  flex: none;
  align-self: stretch;

  display: flex;
  margin: 0;
  padding-left: calc(var(--indent) * var(--u));
}

.start {
  justify-content: flex-start;
}

.center {
  justify-content: center;
}

.end {
  justify-content: flex-end;
}

/* Figma's "Section" component: the plate, sized to its content down the page
 * and fixed across it. */
.plate {
  position: relative;
  flex: none;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: calc(var(--gap) * var(--u));

  width: calc(var(--width) * var(--u));
  padding: calc(var(--pad-block) * var(--u)) calc(var(--pad-inline) * var(--u));
}

/* Figma's GLASS effect. `backdrop-filter` is the closest CSS gets: it blurs
 * what is behind, though it cannot refract it the way Figma's shader does.
 * `--blur` is therefore fitted rather than copied — the payload reports the
 * effect as a bare `{ type: "GLASS" }` with no parameters — at the value that
 * minimises the difference from Figma's own raster over all five plates.
 *
 * The pane is drawn larger than the plate by `--pad` and clipped back down.
 * Chrome samples the backdrop only inside the element's border box and clamps
 * at the edges, so an unpadded pane blurs its own edge pixels outwards instead
 * of pulling in what is actually next to it — and at this radius almost
 * everything a plate shows is pulled in from outside it. */
.glass {
  position: absolute;
  inset: calc(-1 * var(--pad) * var(--u));

  -webkit-backdrop-filter: blur(calc(var(--blur) * var(--u)));
  backdrop-filter: blur(calc(var(--blur) * var(--u)));
  clip-path: inset(calc(var(--pad) * var(--u)) round calc(var(--radius) * var(--u)));
}

/* The pane is absolutely positioned, so without a position of their own these
 * would paint underneath it. */
.heading,
.lines {
  position: relative;
}

.heading {
  margin: 0;
}

.lines {
  display: flex;
  flex-direction: column;
  /* Figma has each line HUG its own text rather than fill the list, and the
   * box is the thing a future link would be clickable over. */
  align-items: flex-start;
  gap: calc(var(--lines-gap) * var(--u));

  margin: 0;
  padding: 0;
  list-style: none;
}
